import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.user.list');
import { OnInit, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-user-list',
template: templateSource || '',
    styles: [``],
})
export class PortalUserListComponent implements OnInit {
    @ViewChild('modalMessage') modalMessage: any;

    public list = [];
    public search = { page: 1, text: '' };
    public facet = { lastpage: 1 };

    public modalOpen = false;
    public modalMode: 'create' | 'edit' = 'edit';
    public selectedEmail: string | null = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load() {
        const res = await wiz.call('search', this.search);
        if (res.code !== 200) return;

        this.list = res.data.list;
        this.facet.lastpage = res.data.lastpage;
        await this.service.render();
    }

    public async goPage(page: number) {
        if (page < 1 || page > this.facet.lastpage) return;
        if (page === this.search.page) return;

        this.search.page = page;
        await this.load();
    }

    public onPageChange = async (page: number) => {
        await this.goPage(page);
    }

    public async doSearch() {
        this.search.page = 1;
        await this.load();
    }

    public async openUser(email: string) {
        this.modalMode = 'edit';
        this.selectedEmail = email;

        this.modalOpen = false;
        await this.service.render();

        this.modalOpen = true;
        await this.service.render();
    }

    public async createUser() {
        this.modalMode = 'create';
        this.selectedEmail = null;

        this.modalOpen = false;
        await this.service.render();

        this.modalOpen = true;
        await this.service.render();
    }

    public handleModalClose = async (updated) => {
        this.modalOpen = false;
        await this.service.render();

        if (updated) {
            setTimeout(async () => {
                await this.modalMessage.open({ 
                    message: '회원정보를 변경하였습니다.' 
                });
                await this.load();
            }, 0);
        }
    };
}

export default PortalUserListComponent;